/** Cuerpo del layout: envuelve el contenido de cada ruta en un Layout.Content con el wrapper de scroll (.body-wrapper). */
import React from "react";
import { Layout } from "antd";

interface LayoutBodyProps {
  children: React.ReactNode;
}

const LayoutBody: React.FC<LayoutBodyProps> = ({ children }) => {
  return (
    <Layout.Content style={{ margin: "8px 8px" }}>
      <div className="body-wrapper">{children}</div>
    </Layout.Content>
  );
};

export default LayoutBody;
